import { render, staticRenderFns } from "./ques-person.vue?vue&type=template&id=8bf9f7ee&scoped=true"
import script from "./ques-person.vue?vue&type=script&lang=js"
export * from "./ques-person.vue?vue&type=script&lang=js"
import style0 from "./ques-person.vue?vue&type=style&index=0&id=8bf9f7ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf9f7ee",
  null
  
)

export default component.exports